import Vue from 'vue/dist/vue.js';
import Notifications from 'vue-notification'
import VueRouter from 'vue-router';
import BrochureRequestForm from './components/BrochureRequestForm.vue';
import VueCookies from 'vue-cookies';


Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(Notifications)

Vue.prototype.$api = process.env.MIX_API_URL

const routes = [
    {
        path: '/',
        name: 'BrochureRequestForm',
        component: BrochureRequestForm
    },
]

const router = new VueRouter({
    routes
})

new Vue({
    router,
    el: '#brochure-request-app',
    data: {
        loading: false,
    },
    computed: {},
    created() {},
    watch: {}
});